import { makeLangStore } from '@pdcplan/shared/hooks';
import {
  langMap,
  languageCodes,
  defaultLanguageCode,
} from '@pdcplan/shared/generated/language/TeamPlan';
import { localStorageGet, localStorageSet } from '../util/localStorage';
import { LocalStorageKey } from '../util/LocalStorageKey';

export const {
  useFormatter,
  getFormatter,
  useLang,
  setCurrentLangCode,
  getLangState,
  useCurrentLangCode,
} = makeLangStore({
  langMap,
  initialAllowedLangCodes: languageCodes,
  initialDefaultLangCode: defaultLanguageCode,
  initialCurrentLangCode: localStorageGet(LocalStorageKey.currentLanguage),
  onSetLang: (lang) => {
    localStorageSet(LocalStorageKey.currentLanguage, lang);
  },
});
